import React, { useState } from "react";
import { CircularProgress, Link, Paper, styled } from "@mui/material";
import { InviteForm } from "./inviteForm";
import { createClinicPatientCase } from "../createClinicPatientCase";
import { useClinicState } from "../../../../clinic/clinicStateContext";
import { InviteData } from "../../util/sendInvitaion";
import { ClinicActionButton } from "fe-web-components/clinic/clinicActionButton";
import { safeCopyToClipboard } from "fe-common/utils/safeCopyToClipboard";
import { ClinicColors } from "fe-web-components/styles/clinicTheme";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { isValidString } from "./common";

//region [[ Styles ]]

const InvitePersonalLinkView = styled(Paper)({
  display: "flex",
  padding: 20,
  flexDirection: "column",
  gap: 20,
});
const FormContainer = styled("div")({
  width: 600,
  maxWidth: "100%",
});
const LinkArea = styled("div")({
  padding: 20,
  flex: "1 0 100%",
  display: "flex",
  alignItems: "center",
  gap: 8,
  border: "1px solid " + ClinicColors.borders,
  borderRadius: 8,
  fontSize: 16,
});

//endregion [[ Styles ]]

//region [[ Props ]]

const COPY_USER_INVITATION_TEXT = "Copy Link";
const COPIED_INVITATION_TEXT = "Link Copied";

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InvitePersonalLink = () => {
  const [
    {
      clinicData: { id: clinicId, name: clinicName },
      defaultLocale,
    },
  ] = useClinicState();

  const dummyInvite: InviteData = {
    patient: {
      firstName: null,
      lastName: null,
      email: null,
      phoneNumber: null,
    },
    visitDateTime: null,
  };

  const [link, setLink] = useState<string>("");
  const [copiedLabel, setCopiedLabel] = useState(null);
  const [generating, setGenerating] = useState<boolean>(false);

  const generateLink = async (inviteData) => {
    setGenerating(true);
    setCopiedLabel(null);
    await createClinicPatientCase(clinicId, inviteData).then((response) => {
      setLink(response.patient);
      setGenerating(false);
      evt({
        category: CATEGORY.CLINIC_MANAGEMENT,
        action: ACTION.CLINIC_INVITE_SENT,
        props: {
          clinicName,
          invitationProperty: "Custom link",
          patientId: response.patient,
          namedFilled:
            isValidString(inviteData?.patient?.firstName) ||
            isValidString(inviteData?.patient?.lastName),
          phoneFilled: isValidString(inviteData?.patient?.phoneNumber),
          emailFilled: isValidString(inviteData?.patient?.email),
          timeOfVisitFilled: !!inviteData?.visitDateTime,
        },
      });
    });
  };

  const onCopyInvitation = () => {
    safeCopyToClipboard(link).then(() => {
      setCopiedLabel(COPIED_INVITATION_TEXT);
      // setTimeout(() => {
      //   setCopiedLabel(null);
      // }, 1000);
    });
  };

  const handleCopy = () => {
    if (copiedLabel) setCopiedLabel("");
    else onCopyInvitation();
  };

  return (
    <InvitePersonalLinkView>
      <FormContainer className={"invite-form-container"}>
        <InviteForm
          inviteData={dummyInvite}
          onSubmit={(inviteData) => generateLink(inviteData)}
          defaultLocale={defaultLocale}
          buttonLabel={"Generate Link"}
          saving={generating}
        />
      </FormContainer>
      {(link || generating) && (
        <LinkArea>
          {generating ? (
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <CircularProgress size={18} /> Creating a new case
            </div>
          ) : (
            <>
              <Link target="_blank" href={link}>
                {link}
              </Link>
              <ClinicActionButton
                label={copiedLabel || COPY_USER_INVITATION_TEXT}
                style={{ marginLeft: "auto" }}
                onClick={handleCopy}
                disabled={generating}
                variant={copiedLabel ? "outlined" : "contained"}
              />
            </>
          )}
        </LinkArea>
      )}
    </InvitePersonalLinkView>
  );
};
